import { VStack, StackTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { SkeletonItemDesktop } from './desktop';
import { SkeletonItemMobile } from './mobile';

export interface SkeletonItemProps {
  length?: number;
  mt?: StackTypes.Props['mt'];
}

export const SkeletonItem: React.FC<SkeletonItemProps> = ({ length = 7, mt }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonItemMobile />,
    lg: <SkeletonItemDesktop />,
  });

  const data = Array.from({ length }, (_, i) => i);

  return (
    <VStack space="inline.quarck" pb="inset.nano" mt={mt}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
